(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactIs"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactIs", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["Spectacle"] = factory(require("React"), require("ReactIs"), require("ReactDOM"));
	else
		root["Spectacle"] = factory(root["React"], root["ReactIs"], root["ReactDOM"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__95827__, __WEBPACK_EXTERNAL_MODULE__30314__) {
return 